import "../apiDocs.css";

export default function Document() {
  return (
    <div className="foo">
      <div
        className="pullRight"
        style={{ width: "100vw", position: "absolute" }}
      >
        <rapi-pdf
          style={{ height: "40px", fontSize: "18px", marginTop: "5px" }}
          include-info="false"
          include-example="true"
          button-label="API Documentation PDF"
          hide-input="true"
          spec-url="CardanoDashboard.yaml"
        >
          {" "}
        </rapi-pdf>
      </div>
      <elements-api apiDescriptionUrl={`${process.env.PUBLIC_URL}/CardanoDashboard.yaml`} router="hash" />
    </div>
  );
}
